document.addEventListener('DOMContentLoaded', function () {
  var e = document.body.className;
  if (!e.includes('template-page-klarna-faq')) return;
  var o = document.querySelectorAll('.faqs-btn'),
    t = document.querySelectorAll('.faqs-btn-two'),
    n = document.querySelector('.faqs-container'),
    r = document.querySelector('.faqs-container-two'),
    a = document.querySelectorAll('.faq-container'),
    c = document.querySelectorAll('.faq-container-two'),
    i = document.querySelectorAll('.faq-bottom'),
    l = document.querySelectorAll('.faq-bottom-two');
  n &&
    r &&
    ((n.style.display = 'none'),
    (r.style.display = 'none'),
    i.forEach(function (e) {
      e.style.display = 'none';
    }),
    l.forEach(function (e) {
      e.style.display = 'none';
    }),
    o.forEach(function (e) {
      e.addEventListener('click', function () {
        n.style.display = 'none' === n.style.display ? 'block' : 'none';
      });
    }),
    t.forEach(function (e) {
      e.addEventListener('click', function () {
        r.style.display = 'none' === r.style.display ? 'block' : 'none';
      });
    }),
    a.forEach(function (e) {
      var o = e.querySelector('.faq-top'),
        t = e.querySelector('.faq-bottom');
      o &&
        t &&
        o.addEventListener('click', function () {
          'none' === t.style.display
            ? ((t.style.display = 'block'), o.classList.add('active'), t.classList.add('active'))
            : ((t.style.display = 'none'),
              o.classList.remove('active'),
              t.classList.remove('active'));
        });
    }),
    c.forEach(function (e) {
      var o = e.querySelector('.faq-top-two'),
        t = e.querySelector('.faq-bottom-two');
      o &&
        t &&
        o.addEventListener('click', function () {
          'none' === t.style.display
            ? ((t.style.display = 'block'), o.classList.add('active'), t.classList.add('active'))
            : ((t.style.display = 'none'),
              o.classList.remove('active'),
              t.classList.remove('active'));
        });
    }));
});
